var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5193 11.8944L21.2938 4.01953H19.6885L13.8061 10.8572L9.10791 4.01953H3.68909L10.7937 14.3592L3.68909 22.6173H5.29453L11.5064 15.3965L16.4681 22.6173H21.8869L14.5189 11.8944H14.5193ZM12.3204 14.4503L11.6005 13.4207L5.87299 5.22809H8.33886L12.9611 11.8398L13.6809 12.8694L19.6892 21.4637H17.2234L12.3204 14.4507V14.4503Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter.bac30671c3a4e6126c4194f142672678.svg";